import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import DropdownC from "../dropdown";
import Buttonc from "../button";
import FilterMobileOptions from "../Filter-mobile-buttons";
// import FilterSingleMobileOptions from '../Filter-single-capsule-mobile-buttons';
// import {
//   optionDelivery,
//   optionOffMarket,
//   options,
//   optionSales,
//   optionStatus,
//   optionVacant
// } from "../../../utils/const";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  occupancy,
  offMarket,
  PossessionDelivery,
  salesInstructions,
  states,
  statusOption
} from "../../property-list/property-listing/sidebar";
const INITIAL_VALUE = {
  state: null,
  status: null,
  salesInstructions: null,
  occupancy: null,
  possessionDelivery: null,
  offMarket: null
};
export default function MobileSliderMenuBody({ reset, setVisibleDrawer }: any) {
  const location = useLocation();
  const [stateValue, setStateValue] = useState<any>(INITIAL_VALUE);
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (reset) {
      setStateValue(INITIAL_VALUE);
      const updatedParams = new URLSearchParams(location.search);
      Object.keys(stateValue).forEach((key) => updatedParams.delete(key));
      setSearchParams(updatedParams);
    }
  }, [reset]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const stateValue = queryParams.get("state");
    const statusValue = queryParams.get("status");
    const salesInstructionsValue = queryParams.get("salesInstructions");
    const occupancyValue = queryParams.get("occupancy");
    const possessionDeliveryValue = queryParams.get("possessionDelivery");
    const offMarketValue = queryParams.get("offMarket");
    setStateValue({
      state: stateValue ?? null,
      status: statusValue ?? null,
      salesInstructions: salesInstructionsValue ?? null,
      occupancy: occupancyValue ?? null,
      possessionDelivery: possessionDeliveryValue ?? null,
      offMarket: offMarketValue ?? null
    });
  }, []);

  function submit() {
    const updatedParams = new URLSearchParams(location.search);
    Object.keys(stateValue).forEach((key) => {
      if (key !== "searchText" && stateValue[key]) {
        updatedParams.set(key, stateValue[key]);
      } else if (key !== "searchText" && !stateValue[key]) {
        updatedParams.delete(key);
      }
    });
    setSearchParams(updatedParams);
    localStorage.setItem("filter", JSON.stringify(stateValue));
    setVisibleDrawer(false);
  }

  function handleChange(name: string, value: string) {
    setStateValue((stateValue: any) => {
      const updatedState: any = {
        ...stateValue,
        [name]: value
      };
      return updatedState;
    });
    
  }

  return (
    <div className={styles.mobileSliderMenuBody}>
      <div className={styles.title}>By States</div>
      <DropdownC
        showClear={false}
        placeholder="State"
        className={styles.dropdownBox}
        tabIndex={6}
        options={states()}
        optionLabel={"name"}
        panelClassName={styles.dropdownList}
        onChange={(e: any) => handleChange("state", e.value.name)}
        value={{ name: stateValue.state, code: stateValue.state }}
        border={true}
      />
      <FilterMobileOptions
        title={"Off Market"}
        optionVacant={offMarket()}
        occupancy={stateValue.offMarket}
        setOccupancy={(value: string) => handleChange("offMarket", value)}
        border={true}
      />
      <FilterMobileOptions
        title={"Sales Instructions"}
        optionVacant={salesInstructions()}
        occupancy={stateValue.salesInstructions}
        setOccupancy={(value: string) =>
          handleChange("salesInstructions", value)
        }
        border={true}
      />
      <FilterMobileOptions
        title={"Occupancy"}
        optionVacant={occupancy()}
        occupancy={stateValue.occupancy}
        setOccupancy={(value: string) => {
          handleChange("occupancy", value);
        }}
        border={true}
      />
      <FilterMobileOptions
        title={"Possession Delivery"}
        optionVacant={PossessionDelivery()}
        occupancy={stateValue.possessionDelivery}
        setOccupancy={(value: string) =>
          handleChange("possessionDelivery", value)
        }
        border={true}
      />
      <FilterMobileOptions
        optionVacant={statusOption()}
        title={"Status"}
        occupancy={stateValue.status}
        setOccupancy={(value: string) => {
          handleChange("status", value);
        }}
      />
      <div className={styles.btnWrap}>
        <Buttonc
          type="button"
          label="Apply"
          size="medium"
          tabIndex={29}
          className={styles.btn}
          onClick={submit}
        />
      </div>
    </div>
  );
}
